import { render, staticRenderFns } from "./locale-switcher.vue?vue&type=template&id=0f0f5e7d&scoped=true"
import script from "./locale-switcher.vue?vue&type=script&lang=js"
export * from "./locale-switcher.vue?vue&type=script&lang=js"
import style0 from "./locale-switcher.vue?vue&type=style&index=0&id=0f0f5e7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0f5e7d",
  null
  
)

export default component.exports